import { render, staticRenderFns } from "./SearchFolder.vue?vue&type=template&id=a78c3864&scoped=true"
import script from "./SearchFolder.vue?vue&type=script&lang=js"
export * from "./SearchFolder.vue?vue&type=script&lang=js"
import style0 from "./SearchFolder.vue?vue&type=style&index=0&id=a78c3864&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a78c3864",
  null
  
)

export default component.exports